export enum MySEStatusEnum {
  OK_NET_PRICE = 'OK_NET_PRICE', // OK just Net prices
  OK_PUBLIC_PRICE = 'OK_PUBLIC_PRICE', // OK just public prices
  OK = 'OK', // OK all mySE prices
  NO_PRICE = 'NO_PRICE',
  NO_REFERENCE = 'NO_REFERENCE',
  NOT_REACHABLE = 'NOT_REACHABLE',
  NOT_APPLICABLE = 'NOT_APPLICABLE'
}
